/**
 * The Console's view of the engine log: which entries show, and the
 * categories a visitor can narrow to. Like Unreal's Output Log filters, with
 * Verbose hidden by default. Commands log under `Cmd`, so filtering to it
 * lists every command the editor ran (the former journal view).
 */
import type { LogEntry, Verbosity } from "../../core/Log";

const HIDDEN: ReadonlySet<Verbosity> = new Set(["Verbose"]);

/** The entries to show: Verbose hidden, optionally one category only (null = all). */
export function filterLog(entries: readonly LogEntry[], category: string | null): LogEntry[] {
  return entries.filter(
    (entry) => !HIDDEN.has(entry.verbosity) && (category === null || entry.category === category),
  );
}

/** Categories used by the shown (non-Verbose) entries, sorted, for the filter menu. */
export function logCategories(entries: readonly LogEntry[]): string[] {
  return [...new Set(filterLog(entries, null).map((entry) => entry.category))].sort();
}
